import React from 'react'
import Img1 from '../Assets/empoweringEducator1.jpg'
import Img2 from '../Assets/empoweringEducator2.jpg'

const empoweringEducatorData = [
  {
    heading: 'Technology Integration',
    para: 'Provide educators with access to innovative technologies and digital learning tools to enhance instruction and student engagement.',
    image: Img1,
  },
  {
    heading: 'Professional Development',
    para: 'Offer ongoing professional development opportunities to ensure educators are equipped with the latest teaching methodologies and industry insights.',
    image: Img2,
  },
]

const EmpoweringEducators = () => {
  return (
    <section className='home_section'>
      <span className='home_eyebrow'>Educators</span>
      <h2 className='home_heading'>Empowering educators</h2>
      <p className='home_lead'>We are committed to supporting and empowering educators with the tools, resources, and professional development opportunities they need to deliver high-quality instruction.</p>

      <div className='bento'>
        {empoweringEducatorData.map(({ heading, para, image }, index) => (
          <div className='bento_card span-3 has-image' key={index}>
            <div className='bento_photo' style={{ backgroundImage: `url(${image})` }} role='img' aria-label={heading} />
            <div className='bento_body'>
              <h3 className='bento_title'>{heading}</h3>
              <p className='bento_para'>{para}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default EmpoweringEducators
